import { Button } from '@ui';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import { cn } from '~/lib/cn';
import SuccessConfetti from '../public/lottie/success_confetti.json';
import { CompletedAnimation } from './Animations/CompletedAnimation';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface Props {
    callback?: (...args: any[]) => any;
    message?: string;
    title?: string;
    // lets the confirm button run its own bar and press itself after this long — used at the
    // kiosk, where nobody should have to tap "Abschließen" before the undo bar becomes reachable
    autoCloseMs?: number;
    // stretches over the parent's height: content centered, button pinned to the bottom edge
    fill?: boolean;
}

const Confirmation: FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    callback,
    message = 'Viel Spass beim Spiel!',
    title = 'Deine Buchung war erfolgreich!',
    autoCloseMs,
    fill
}) => {
    return (
        <div
            className={cn(
                'tw-my-2 tw-flex tw-flex-col tw-justify-center tw-gap-4 tw-text-center',
                fill && 'tw-my-0 tw-flex-1'
            )}
        >
            <div className={cn('tw-flex tw-flex-col tw-gap-4', fill && 'tw-flex-1 tw-justify-center')}>
                <div className="tw-relative tw-overflow-hidden">
                    <Lottie animationData={SuccessConfetti} className="tw-absolute -tw-inset-20 tw-blur-[2px]" />
                    <CompletedAnimation />
                </div>
                <h1 className="tw-text-accents-8">{title}</h1>
                <span className="tw-text-sm tw-text-accents-6">{message}</span>
            </div>
            {callback && (
                <Button block autoCloseMs={autoCloseMs} onPress={() => callback?.()}>
                    Abschließen
                </Button>
            )}
        </div>
    );
};

export default Confirmation;
